import { createSlice } from "@reduxjs/toolkit";
import {
  DataResponseAccesoQR,
  DataUser,
  InfoQR,
  JuzgadosEdificios,
  TableMenores,
  filesIne,
} from "interfaces/accesoEdificios/accesoEdificiosInterface";

type accesosEdificios = {
  lstJuzgadosEdificios: JuzgadosEdificios[] | [];
  datosUsuario: DataUser | null;
  fileIneF: filesIne | null;
  fileIneR: filesIne | null;
  qrGenerated: DataResponseAccesoQR | null;
  infoQr: InfoQR | null;
  lstDiscapacidades: Discapacidades[];
  lstSubdiscapacidades: any[];
  lstMenores: TableMenores[];
  discapacidad: Boolean;
  conMenor: Boolean;
  dataQR: any;
};
export interface Discapacidades {
  key:       number;
  label:     string;
  children?: SubDiscapacidades[];
}

export interface SubDiscapacidades {
  key:   string;
  label: string;
}

export const accesoEdificiosSlice = createSlice({
  name: "accesoEdificios",
  initialState: {
    lstJuzgadosEdificios: [],
    datosUsuario: null,
    fileIneF: null,
    fileIneR: null,
    qrGenerated: null,
    infoQr: null,
    lstDiscapacidades: [],
    lstSubdiscapacidades: [],
    lstMenores: [],
    discapacidad: false,
    conMenor: false,
    dataQR: null,
  } as accesosEdificios,
  reducers: {
    onLoadJuzgadosEdificios: (state, { payload }) => {
      state.lstJuzgadosEdificios = payload;
    },
    onLoadDatosUsuario: (state, { payload }) => {
      state.datosUsuario = payload;
    },
    onLoadFileIneFrente: (state, { payload }) => {
      state.fileIneF = payload;
    },
    onLoadFileIneAtras: (state, { payload }) => {
      state.fileIneR = payload;
    },
    onLoadDataQR: (state, { payload }) => {
      state.qrGenerated = payload;
    },
    onLoadInforQr: (state, { payload }) => {
      state.infoQr = payload;
    },
    onLoadLstDiscapacidades: (state, { payload }) => {
      state.lstDiscapacidades = payload;
    },
    onLoadMenor: (state, { payload }) => {
      state.lstMenores = [...state.lstMenores, payload];
    },
    onDeleteMenor: (state, { payload }) => {
      state.lstMenores = state.lstMenores.filter(
        (pMenor) => pMenor.id !== payload
      );
    },
    onChangeDiscapacidad: (state, { payload }) => {
      state.discapacidad = payload;
    },
    onChangeConMenor: (state, { payload }) => {
      state.conMenor = payload;
    },
    onLoadVerifyQR: (state, { payload }) => {
      state.dataQR = payload;
    },
    onLoadLstSubDiscapacidades: (state, { payload }) => {
      state.lstSubdiscapacidades = payload;
    },
  },
});

export const {
  onLoadDataQR,
  onLoadDatosUsuario,
  onLoadFileIneAtras,
  onLoadFileIneFrente,
  onLoadInforQr,
  onLoadJuzgadosEdificios,
  onLoadLstDiscapacidades,
  onLoadMenor,
  onDeleteMenor,
  onChangeDiscapacidad,
  onChangeConMenor,
  onLoadVerifyQR,
  onLoadLstSubDiscapacidades,
} = accesoEdificiosSlice.actions;
